import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Card, Typography, Grid } from '@mui/joy';
import { PieChart } from '@mui/x-charts';
import axios from 'axios';
import domain from "../../../util/domain";

export default function Distribution() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDistribution = async () => {
            try {
                const response = await axios.get(`${domain}/frontoffice/feedback/distribution`);
                setData(response.data);
            } catch (error) {
                console.error('Error fetching distribution:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchDistribution();
    }, []);

    if (loading) return <CircularProgress />;

    const groupDataByCategory = (data) => {
        return data.reduce((acc, item) => {
            if (!acc[item.category]) {
                acc[item.category] = [];
            }
            acc[item.category].push(item);
            return acc;
        }, {});
    };

    const getChartData = (categoryData) => {
        return categoryData.map(item => ({
            id: item.rating,
            value: parseInt(item.count),
            label: `Rating ${item.rating} (${item.percentage}%)`
        }));
    };

    const groupedData = data ? groupDataByCategory(data) : {};

    return (
        <Grid container spacing={2}>
            {Object.entries(groupedData).map(([category, categoryData]) => (
                <Grid xs={12} md={6} key={category}>
                    <Card variant="outlined" sx={{ p: 2 }}>
                        <Typography level="h4" sx={{ mb: 2, textAlign: 'center' }}>
                            {category}
                        </Typography>
                        <PieChart
                            series={[{
                                data: getChartData(categoryData),
                                highlightScope: { faded: 'global', highlighted: 'item' },
                                faded: { innerRadius: 30, additionalRadius: -30 }
                            }]}
                            height={300}
                            slotProps={{
                                legend: {
                                    direction: 'row',
                                    position: { vertical: 'bottom', horizontal: 'middle' },
                                    padding: 0
                                }
                            }}
                        />
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
} 